
window.saferEval = function(expression, dataContext) {
    try{
        return (new Function(['$data'], `var result; with($data) { result = ${expression} }; return result`))(dataContext)
    } catch(e){
        console.log('Safer eval error: '+e)
        return;
    }
}

window.processElement = function(el,key){

    var data = [];

    if (el.hasAttribute('class')){
        el.__x_original_classes = el.getAttribute('class').split(' ')
    }
    Array.from(el.attributes)
    .filter(attr=>{
        return xAttrRE.test(attr.name);
    }).map(attr=>{
        const name = attr.name
        const typeMatch = name.match(xAttrRE)
        const valueMatch = name.match(/:([a-zA-Z\-:]+)/)
        const modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || []

        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map(i => i.replace('.', '')),
            expression: attr.value,
        }
    }).forEach(({ type, value, modifiers, expression }) => {
        // console.log('found',{ type, value, modifiers, expression });
        let output = '';
        switch (type) {
            case 'bind':
                output = el.hasAttribute(value)?el.getAttribute(value):'';
                // console.log('data inserted',expression,output);
                data.push({
                    key:expression,
                    value:output,
                })
                break;
            case 'text':
                output = el.innerText;
                // console.log('data inserted',expression,output);
                data.push({
                    key:expression,
                    value:output,
                })
                break;
            case 'html':
                output = el.innerHTML;
                // console.log('data inserted',expression,output);
                data.push({
                    key:expression,
                    value:output,
                })
                break;
            case 'show':
                output = el.style.display;
                if(output && output=='none'){
                    output = false;
                } else {
                    output = true;
                }
                // console.log('data inserted',expression,output);
                data.push({
                    key:expression,
                    value:output,
                })
                break;
            case 'style':
                var matches = expression.match(/.*?['"]?([^'":]+?)['"]? *: *(.+?) *[,}]/g);
                if(matches) for(var i in matches){
                    var match = matches[i].match(/.*?['"]?([^'":]+?)['"]? *: *(.+?) *[,}]/);
                    data.push({
                        key:match[2],
                        value:el.style.getPropertyValue(match[1]),
                    });
                }

                break;
    //                case 'for':
    //                    handleForDirective(this, el, expression, initialUpdate, extraVars)
    //                    break;
            default:
                break;
        }
    })

    return data;
}

const xAttrRE = /^x-(bind|text|html|for|show|style)\b/;

window.initializeElements = function(rootEl) {
    var data = {};
    var resloop = [];
    walkAndSkipLoops(rootEl, el => {
        processElement(el)
        .forEach(i => {
            data[i.key] = i.value
        })
    }, el => {
        var match = el.getAttribute('x-for').match(/(.*) in (.*)/);
        if(!match) return;
        var parentKey = match[2];
        var childKey = match[1];
        if(!data[parentKey]) data[parentKey] = [];

        var childObj = {};
        walkAndSkipBlocks(el,childElm=>{
            processElement(childElm)
            .forEach(i => {
                if(i.key.match(new RegExp(`^${childKey}.`))){
                    var key = i.key.replace(new RegExp(`^${childKey}.`),'');
                    childObj[key] = i.value;
                } else if(i.key.match(/^[^.]+$/)) {
                    data[i.key] = i.value
                }
            })
        })
        data[parentKey].push(childObj);
    })
    return data;
}

window.walkAndSkipLoops = function(el, callback, initializeLoopCallback = () => {}) {
    walk(el, el => {

        try{
            if (el.className.match(/\bblock-block\d+/)) return false;
        } catch(e){
            return false;
        }
        if (el.hasAttribute('x-for')) {
            initializeLoopCallback(el)
            return false
        }

        return callback(el)
    })
}

window.walkAndSkipBlocks = function(el, callback, initializeLoopCallback = () => {}) {
    walk(el, el => {

        //skip subblocks
        //FIXME not working when block is inside x-for
        try{
            if (el.className.match(/\bblock-block\d+/)) return false;
        } catch(e){
            return false;
        }

        return callback(el)
    })
}


window.walk = function(el, callback) {
    if (callback(el) === false) return;
    let node = el.firstElementChild
    while (node) {
        walk(node, callback)
        node = node.nextElementSibling
    }
}

window.walkLvl = function(el,level, callback) {
    level = callback(el,level);
    let node = el.firstElementChild
    while (node) {
        walkLvl(node,level, callback)
        node = node.nextElementSibling
    }
}

window.resetValues = function(obj){
	let i;
	for (i in obj){
		if(typeof(obj[i])=='string') obj[i] = '';
		if(typeof(obj[i])=='object') obj[i] = resetValues(obj[i]);
		//if(typeof(val)=='number') return 0
	}
	return obj;
}
window.clone = function(obj){
	return JSON.parse(JSON.stringify(obj))
}
window.extractUrl = function(string){

	var match = string.match(/url\(([^)]+)\)/i);
	if(match) return match.pop();
	var match = string.match(/^https?:\/\/[^\s]+/i);
	if(match) return match.pop();
	return '';
}


window.isMobile = function(){
	if(window.navigator.userAgent.match(/Android/i)) return true;
	if(window.navigator.userAgent.match(/iPhone|iPad/i)) return true;
	return false;
}



window.uniqid = function(prefix){
  var str = ''
  if(prefix) str = prefix;
  var charcode = Math.floor(Math.random() * 26) + 97; // a-z
  str+=String.fromCharCode(charcode);
  str+=Math.floor(Math.random() * 1000000);
  str+=new Date().getTime()
  return str;
}

window.json_encode = function(obj){
	return JSON.stringify(obj,null,"\t");
}


window.looseJsonParse = function(obj){
    return Function('"use strict";return (' + obj + ')')();
 }



window.getDataFromCss = function(css){
    var data = {};
    if(!css) css = '';

    var matches = css.match(new RegExp(`--[a-z0-9_-]+:[^;]+;`,'ig'));
	if(matches) for(var i in matches){
		var match = matches[i].match(new RegExp(`--([a-z0-9_-]+):([^;]+);`,'i'))
		var field = match[1];
		var value = match[2];
		data[field] = value.trim();
	}
    return data;
    /*

    for(var selector in model){
        if(!selector.startsWith('css/')) continue;
        var match = selector.match(/^css\/([^/]+)\/(.+)$/);
        if(!match) continue;
        console.log('model css selector matches',selector,match[1],match[2]);

        var match = css.match(new RegExp(`${match[1]} ?{[^}]+${match[2]}:([^;]+);`))
        if(!match) continue;
        console.log('model css selector  value',selector,match[1]);
        data[selector] = match.pop().trim();

    }
    return data;
    /**/


}


window.htmlToDom = function(html){
    if(html.trim().match(/^<(tr|td)/)){
        var dom = document.createElement('table');
    } else {
        var dom = document.createElement('div');
    }
	dom.innerHTML = html;
	return dom.firstChild;
}

window.capitalizeFirstLetter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

window.renderTemplateUpdate = function(template,field,value){

	if(Array.isArray(value)){
		return renderTemplateLoopSet(template,field,value);
	}
	console.log('renderTemplateUpdate',field,value);

    if(template.trim().match(/^<(tr|td|tbody|thead)/)){
        var dom = document.createElement('table');
    } else {
        var dom = document.createElement('div');
    }

    dom.innerHTML = template;

    if(value===undefined || value===null) value='';

    dom.querySelectorAll(`[x-text="${field}"]`).forEach(elm=> { elm.innerHTML = value });
    dom.querySelectorAll(`[x-html="${field}"]`).forEach(elm=> { elm.innerHTML = value });

    var regexp = new RegExp(`x-bind:([a-z-]+)="${field}"`,'ig');
    var matches = template.match(regexp)
    if(matches) for(var i in matches){
        var regexp = new RegExp(`x-bind:([a-z-]+)="${field}"`,'i');
        var match = matches[i].match(regexp)
        var attribute = match.pop();
        if(dom.hasAttribute(`x-bind:${attribute}`) && dom.getAttribute(`x-bind:${attribute}`)==field) {
            if(value){
                dom.setAttribute(attribute,value);
            } else {
                dom.removeAttribute(attribute);
            }
        }
        dom.querySelectorAll(`[x-bind\\:${attribute}="${field}"]`).forEach(elm=>{
            if(value){
                elm.setAttribute(attribute,value)
            } else {
                elm.removeAttribute(attribute);
            }
        });
	}

    var regexp = new RegExp(`x-show="${field}"`,'ig');
    var matches = template.match(regexp)
    if(matches) for(var i in matches){
        var regexp = new RegExp(`x-show="${field}"`,'i');
        var match = matches[i].match(regexp)
        if(dom.hasAttribute(`x-show`) && dom.getAttribute(`x-show`)==field) {
            dom.style.display = (!value?'none':'');
        }
        dom.querySelectorAll(`[x-show="${field}"]`).forEach(elm=>{ elm.style.display = (!value?'none':''); });
    }

    var regexp = new RegExp(`x-style=".*?['"]?([^'":]+?)['"]?: ?${field}\\b`,'ig');

    var matches = template.match(regexp)
    if(matches) for(var i in matches){
        var regexp = new RegExp(`x-style=".*?['"]?([^'":]+?)['"]?: ?${field}\\b`,'i');
        var match = matches[i].match(regexp)
        var prop = match[1];

        if(dom.hasAttribute(`x-style`) && dom.getAttribute(`x-style`).includes(field)) {
            dom.style.setProperty(prop,value);
        }
        dom.querySelectorAll(`[x-style]`).forEach(elm=>{
            if(elm.getAttribute(`x-style`).includes(field)) {
                elm.style.setProperty(prop,value);
            }
        });
    }

	return dom.innerHTML;
}

window.renderCssUpdate = function(css,field,value){

        /*
    if(dom.querySelector('style')){
        var stylesheet = dom.querySelector('style').innerHTML;
        var regexp = new RegExp(`--${field}:([^;]+);`);
        var stylesheet_updated = stylesheet.replace(regexp,`--${field}: ${value};`)
        if(stylesheet_updated!=stylesheet) dom.querySelector('style').innerHTML = stylesheet_updated;
    } else if(css) {
        */
        var stylesheet = css;
        var regexp = new RegExp(`--${field}:([^;]*);`);
        var stylesheet_updated = stylesheet.replace(regexp,`--${field}: ${value};`)
        if(stylesheet_updated!=stylesheet) css = stylesheet_updated;
    /* } */
    return css;
}



window.renderJsUpdate = function(js,field,value){
	if(!js) return js;
	if(typeof js!='string') return js;
	let lines = js.split("\n");
	var regexp = new RegExp(`//.*\\$\{${field}\}.*`,'g');

	const tempMappings = {};

	const match = js.match(regexp);
	if(!match) return js;

	var regexpLine = new RegExp(`//(.*)\\$\{${field}\}(.*)`);

	for(let i=0;i<match.length;i++){
		const linha = match[i];

		const matchLinha = linha.match(regexpLine);
		const updatedLine = `${matchLinha[1]}${value}${matchLinha[2]}`;
		const index = lines.findIndex(line=>line==linha);

		const tempCode = '//'+crypto.randomUUID();
		tempMappings[tempCode] = linha;
		lines[index] = tempCode
		lines[index+1] = updatedLine;
	}
	for(const tempCode in tempMappings){
		const index = lines.findIndex(line=>line==tempCode);
		lines[index] = tempMappings[tempCode];
	}
	return lines.join('\n');

}


window.getSourceData = async function(source,project_id){

    var match = source.match(/^(api|db):(.+)$/);
    if(!match) return [];
    var sourceType = match[1];
    var sourceName = match[2];

    if(sourceType=='db'){
        var results = [];
        await fetch(`/api/project/${project_id}/db/${sourceName}/data`)
        .then(response => response.json())
        .then(data => { results = data} );
        return results;

      /*
        axios.get().then(res=>{
            this.sourceData = res.data;
            this.isLoadingSource = false;
        }).catch(error=>{
            this.isLoadingSource = false;
            alert(error.response.data);
            console.log('error',error.response.data);
        });
        */
      }
      if(sourceType=='api'){
        var results = [];
        var url = sourceName;
        if(!sourceName.match(/https:\/\/api\.themedeploy/)){
            url = 'https://api.themedeploy.com/api/fetch?url='+encodeURIComponent(sourceName);
        }

        await fetch(url)
         .then(response => response.json())
         .then(data => {
			if(!Array.isArray(data) && Array.isArray(data.data)) return results = data.data;
			if(!Array.isArray(data) && Array.isArray(data.results)) return results = data.results;
			results = data
		} );
		// limit to 100 records
		if(results.length>100) results = results.slice(0,100);
        return results;

        // this.isLoadingSource = true;
        /*

        axios.get(this.sourceName).then(res=>{
            this.sourceData = res.data;
            this.isLoadingSource = false;
        }).catch(error=>{
            this.isLoadingSource = false;
            alert(error.response.data);
            console.log('error',error.response.data);
        });
        */


      }

}

window.renderTemplateLoopUpdate = function(template,parentKey,index,subfield,value){


	console.log('renderTemplateLoopUpdate',parentKey,index,subfield,value);

    var dom = document.createElement('div');
    dom.innerHTML = template;

    var elements = dom.querySelectorAll(`[x-for$="in ${parentKey}"]`);
    if(!elements) return;

    index = parseInt(index);
    var element = elements[index];
    if(!element) return;

    var childKey = element.getAttribute('x-for').match(/^([a-zA-Z0-9-]+) in /).pop();
    element.outerHTML = renderTemplateUpdate(element.outerHTML,`${childKey}.${subfield}`,value);

    return dom.innerHTML;
}


window.renderTemplateLoopAdd = function(template,parentKey){
    var dom = document.createElement('div');
    dom.innerHTML = template;

    //get first element and find its siblings (in case some subcomponent has loop too)
    var firstElement = dom.querySelector(`[x-for$="in ${parentKey}"]`);
    var parentNode = firstElement.parentNode;
    var elements = parentNode.querySelectorAll(`:scope > [x-for$="in ${parentKey}"]`);

    //copy last object
    var lastElement = elements[elements.length-1];
    var parentNode = lastElement.parentNode;
    var clone = lastElement.cloneNode(true);


    //remove any subblock
    clone.querySelectorAll('[class^="block-block"]').forEach(subblock => { subblock.parentNode.removeChild(subblock); })


    parentNode.appendChild(clone);
    parentNode.appendChild(document.createTextNode("\n"));

    return dom.innerHTML;
}


window.findContext = function(block_uid){

	var currentblock = iframeDom.document.querySelector('.block-'+block_uid);
	var parent = currentblock.closest('[x-for*="in table"]');
	if(!parent) return null;
	var parentBlock = parent.closest('[x-vars]');
	if(!parentBlock) return null;
	var xVars = looseJsonParse(parentBlock.getAttribute('x-vars'));
	for(var field in xVars){
		if(xVars[field].type=='dbtable') return xVars[field].dbtable;
	}
	return null;
}

window.renderTemplateLoopRemove = function(template,parentKey,index){
    var dom = document.createElement('div');
    dom.innerHTML = template;

    //get first element and find its siblings (in case some subcomponent has loop too)
    var firstElement = dom.querySelector(`[x-for$="in ${parentKey}"]`);
    var parentNode = firstElement.parentNode;
    var elements = parentNode.querySelectorAll(`:scope > [x-for$="in ${parentKey}"]`);

    index = parseInt(index);
    var element = elements[index];
    element.parentNode.removeChild(element);
    return dom.innerHTML;
}

window.renderTemplateLoopSet = function(template,field,data){
	  console.log('renderTemplateLoopSet',field,data);
    //[{"id":1,"name":"primeira carta","created_at":"2020-07-06T03:09:44.000000Z","carta":"carta xyz","valor":"30.000"},{"id":2,"name":"segunda carta","created_at":"2020-07-06T03:10:06.000000Z","carta":"carta xyz2","valor":"45.000"}]
    var dom = document.createElement('div');
    dom.innerHTML = template;

    //get first element and find its siblings (in case some subcomponent has loop too)
    var firstElement = dom.querySelector(`[x-for$="in ${field}"]`);
    var parentNode = firstElement.parentNode;
    var elements = parentNode.querySelectorAll(`:scope > [x-for$="in ${field}"]`);

    //remove all, keep 1 only
    while(elements.length>1) {
       parentNode.removeChild(elements[1]);
       elements = parentNode.querySelectorAll(`:scope > [x-for$="in ${field}"]`);
    }

    var childKey = firstElement.getAttribute('x-for').match(/^([a-z0-9-]+) in /).pop();
    var i,f, element;
    for(i=0;i<data.length;i++){
        if(i==0){
            element = firstElement;
        } else {
            var clone = firstElement.cloneNode(true);
            element = parentNode.appendChild(clone);
            //parentNode.appendChild(document.createTextNode("\n"));
            //remove any subblock
            //clone.querySelectorAll('[class^="block-block"]').forEach(subblock => { subblock.parentNode.removeChild(subblock); })
        }
				var template = element.outerHTML;
				if(typeof(data[i])=='string'){
					template = renderTemplateUpdate(template,`${childKey}`,data[i]);
				} else {
					for(f in data[i]){
						template = renderTemplateUpdate(template,`${childKey}.${f}`,data[i][f]);
					}
				}
        element.outerHTML = template;
    }

//    console.log(dom.innerHTML);


    return dom.innerHTML;
}


window.modelToString = function(xVars){
    return JSON.stringify(xVars,null,'\t')
    .replace(/"/g,`'`)
    .replace(/'([^' -]+)':/g,'$1:')
    .replace(/:\s*'([^'\n]*'[^'\n]*'[^'\n]*)'/g,":\`$1\`");
}

window.updateXVars = function(blockObj,field,attr,value){
	var dom = htmlToDom(blockObj.template);
	var xVars = looseJsonParse(dom.getAttribute('x-vars')) || {};
	xVars[field][attr] = value;
	dom.setAttribute('x-vars',modelToString(xVars));
	blockObj.template = dom.outerHTML;
}


window.renderDataIntoFieldDb = function(column,childKey,field,value){
	var xVars;

	console.log('renderDataIntoFieldDb',childKey,field,value);

	column.querySelectorAll('[x-vars]').forEach(block=>{
		xVars = looseJsonParse(block.getAttribute('x-vars'))
		var parentNode = block.parentNode;
		for(var varsItem in xVars){
			if(xVars[varsItem].dbfield==field){
				if(Array.isArray(value)){
					var newblockhtml = renderTemplateLoopSet(parentNode.innerHTML,varsItem,value)
				} else {
					var newblockhtml = renderTemplateUpdate(parentNode.innerHTML,varsItem,value)
				}
				parentNode.innerHTML = newblockhtml;
			}
		}
	})

}



window.toastr = function(body,title,color,seconds){

    title = title || '';
    color = color || '#007aff'
    seconds = seconds || (2 + body.length/50);

    var div = document.createElement('div');
    div.className = 'toast show';
    div.setAttribute('style','min-width:200px; position: fixed; bottom: 10px; right: 10px;');
    div.innerHTML = `
    <div class="toast-header">
        <svg class="bd-placeholder-img rounded mr-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"><rect width="100%" height="100%" fill="${color}"></rect></svg>
      <strong>${title}</strong>
    </div>
    <div class="toast-body">
      ${body}
    </div>`;
    document.body.appendChild(div);

    setTimeout(()=>{
        document.body.removeChild(div);
    },seconds*1000);

}
